module.exports = __webpack_public_path__ + "img/image-preview.bf299dea.jpeg";